import { useLocation } from "@tanstack/react-router";
import { ReactNode } from "react";

import { AppRedirect } from "./AppRedirect";
import { PaidFeature, useAuth, UserRole } from "./AuthContext";

export function ProtectedRoute({
  children,
  requiredFeatures,
  requiredRoles,
}: {
  children: ReactNode;
  requiredFeatures?: PaidFeature[];
  requiredRoles?: UserRole[];
}) {
  const { user, loading, hasFeature, hasRole } = useAuth();
  const location = useLocation();

  if (loading) return <div className="p-8 text-center text-sm text-slate-500">Loading session...</div>;
  if (!user) return <AppRedirect to="/login" />;
  if (user.must_change_password && location.pathname !== "/change-password") {
    return <AppRedirect to="/change-password" />;
  }
  if (requiredRoles && !hasRole(...requiredRoles)) {
    return (
      <div className="rounded-lg border bg-white p-8 text-center">
        <h2 className="text-xl font-semibold text-slate-950">Access denied</h2>
        <p className="mt-2 text-sm text-slate-600">
          This page requires {requiredRoles.join(", ")}. Your role is {user.role}.
        </p>
      </div>
    );
  }
  if (requiredFeatures && !hasFeature(...requiredFeatures)) {
    return (
      <div className="rounded-lg border bg-white p-8 text-center">
        <h2 className="text-xl font-semibold text-slate-950">Add-on not active</h2>
        <p className="mt-2 text-sm text-slate-600">
          Speed to Lead is a paid add-on and is disabled for this tenant.
        </p>
      </div>
    );
  }
  return <>{children}</>;
}
